<template>
    <div class="pn-duc-deg-fix-panel">
        <div class="add-pn-count-message">
            Add PN count
        </div>
        <div class="pn-count-info">
            <label for="pn-value" id="label-pn-value">PN</label>
            <div class="input-save-container">
                <input type="number" id="pn-value" name="pn-value" v-model="selectedCount" placeholder="#">
                <i class="fa fa-pencil pn-value-pencil" />
                <button class="pn-save" @click="prepareUpdatePn">{{ $translate('Save') }}</button>
            </div>
        </div>
        <div v-if="confirmUpdatePn" class="pn-change-confirmation-dialog">
            <div class="inner-text">

                <span class="warning-label">Warning:</span> Please note that changing the PN count may impact the score. Do you wish to proceed?
            </div>
            <hr />
            <b-button @click="cancelUpdatePn()" class="mr-5">No</b-button>
            <b-button 
                variant="primary"
                :title="$translate('yes')"
                @click="updatePN()"
            class="ml-5">Yes</b-button>
        </div>
        <!-- <div v-if="pnCount >= 0" class="pn-count-info" :class="{ hazard: pnHazard }">
            <img v-b-tooltip.hover class="score-hazard-icon" :title="$uiUtils.formatPnHazardMessage(pnCount)"
                src="/static/svg/Hazard_PN_white.svg" alt="" />

            <span class="pn-value">{{ pnText }}</span>
        </div> -->

        <!-- <span class="duc" :class="{ hazard: hasDuc }">{{ $translate('duc') }}</span> -->

        <!-- <span class="deg" :class="{ hazard: isDeg }">{{ $translate('deg') }}</span> -->

        <!-- <div class="actions">
            <changed-by-user v-if="isChanged" />

            <b-button v-if="!isComparePage" variant="transparent" class="edit-btn">
                <i class="fa fa-pencil" />
            </b-button>
        </div> -->

        <!-- <pn-duc-deg-dialog
            v-if="showEditDialog"
            :well="well"
            :pn-count="pnCount"
            :pn-count-time="pnCountTime"
            :has-duc="hasDuc"
            :is-degenerated="isDeg"
            @hide="toggleEditDialog(true)"
        /> -->
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PnDucDegDialog from './PnDucDegDialog'
import ChangedByUser from './ChangedByUser'
import { TREATMENT_PAGE_VIEWS } from '../../../business/const'
import UIUtils from '../../../business/utils/UIUtils'
import BackendProvider from '../../../business/services/BackendProvider'

export default {
    name: 'PnDucDegFixPanel',
    components: {
        ChangedByUser,
        PnDucDegDialog
    },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showEditDialog: false,
            selectedCount : this.well.inferenceOverridingData.pnCount.value || this.well.inferenceData.pnCount.value,
            confirmUpdatePn: false
        }
    },
    computed: {
        ...mapState({
            videoPlaybackReady: state => state.timelapse.videoPlaybackReady,
            shareDialogOpened: state => state.timelapse.shareDialogOpened,
            currentView: state => state.navigation.currentView,
            shareToPatientDialogOpened: state => state.timelapse.shareToPatientDialogOpened
        }),
        ...mapGetters({
            getPnCount: 'timelapse/getPnCount',
            getPnCountTime: 'timelapse/getPnCountTime',
            getPnHazard: 'timelapse/getPnHazard',
            getPnText: 'timelapse/getPnText',
            checkDucsHazard: 'timelapse/checkDucsHazard',
            checkDegHazard: 'timelapse/checkDegeneratedOocyteHazard'
        }),
        pnCount() {
            return this.getPnCount(this.well)
        },
        pnCountTime() {
            return this.getPnCountTime(this.well)
        },
        pnHazard() {
            return this.getPnHazard(this.well)
        },
        pnText() {
            return this.getPnText(this.well)
        },
        hasDuc() {
            return this.checkDucsHazard(this.well)
        },
        isDeg() {
            return this.checkDegHazard(this.well)
        },
        isChanged() {
            const { inferenceOverridingData: overriding } = this.well

            const isPnChanged = overriding.hasOwnProperty('pnCount')
            const isDucChanged = overriding.hasOwnProperty('duc')
            const isDegChanged = overriding.hasOwnProperty('degeneratedOocyte')

            return isPnChanged || isDucChanged || isDegChanged
        },
        isComparePage() {
            return (
                this.$route.name === this.$paths.TREATMENTS &&
                this.currentView === TREATMENT_PAGE_VIEWS.COMPARE_WELLS
            )
        },
        cursorClass() {
            return !this.videoPlaybackReady
                ? 'progress'
                : this.isComparePage
                ? 'default-cursor'
                : 'pointer'
        }
    },
    watch: {
        shareDialogOpened(isOpen) {
            if (isOpen) {
                this.showEditDialog = false
            }
        },
        shareToPatientDialogOpened(isOpen) {
            if (isOpen) {
                this.showEditDialog = false
            }
        },
        pnCount(value){
            this.selectedCount = value;
        }
    },
    methods: {
        toggleEditDialog(isForce = false) {
            if (this.isComparePage) {
                return
            }
            if (!this.videoPlaybackReady && isForce !== true) {
                return
            }
            if (!this.showEditDialog) {
                this.$store.commit('timelapse/shareDialogOpened', false)
                this.$store.commit('timelapse/shareToPatientDialogOpened', false)
            }
            this.showEditDialog = !this.showEditDialog
        },
        async prepareUpdatePn(){
            this.$log.actionEvent('prepare_change_well_pn_count');
            if(this.pnCountExists()){
                this.confirmUpdatePn = true;
            }else{
                await this.updatePN();
            }
        },
        async updatePN() {
            this.$log.actionEvent('change_well_pn_count')

            const pnCount = {
                value: +this.selectedCount,
                time: null
            }   
            this.confirmUpdatePn = false;
            await this.saveChanges({ pnCount })
            
        },
        async saveChanges(delta) {
            UIUtils.showLoadingMask()

            await BackendProvider.updateInference(this.well._id, delta)

            this.$store.commit('timelapse/triggerWellReFetch', true)
        },
        cancelUpdatePn(){
            this.confirmUpdatePn = false;
        },
        pnCountExists(){
            const overridingDataPnCount = this.well.inferenceOverridingData.pnCount;
            const pnCount = this.well.inferenceData.pnCount;
            const pnCountExists = !!(
                (overridingDataPnCount && overridingDataPnCount.value) || 
                (pnCount && pnCount.value)
            );
            return pnCountExists;
        }
    }
}
</script>

<style lang="scss" scoped>
.pn-duc-deg-fix-panel {
    position: relative;
    padding: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;

    &.progress {
        cursor: progress;
        height: auto;
        line-height: normal;
        background-color: $dark-3;
    }
    &.pointer {
        cursor: pointer;
    }
    &.default-cursor {
        cursor: default;
    }

    .input-save-container {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
    }

    #pn-value {
        border: 1px solid #BCBCBC;
        background-color: #4A4A55;
        color: #FFFFFF;
        border-radius: 4px;
        height: 50px;
        width: 214px;
        padding-left: 20px;
        padding-right: 30px;
        -webkit-appearance: none;
        -moz-appearance: textfield;
    }

    #pn-value::-webkit-inner-spin-button,
    #pn-value::-webkit-outer-spin-button {
        -webkit-appearance: none;
    }

    #label-pn-value {
        padding-top: 1rem;
        width: 24px;
        height: 19px;
        text-align: left;
        font: normal normal medium 16px/18px Montserrat;
        letter-spacing: 0px;
        color: #BCBCBC;
    }

    .pn-value-pencil {
        position: relative;
        left: 90px;
        top: -30px;
        // transform: translateY(-50%);
        pointer-events: none;
        color: #7A7A7D;
    }
    .add-pn-count-message {
        text-align: left;
        font: normal normal normal 16px/18px Montserrat;
        letter-spacing: 0px;
        color: #FFFFFF;
        padding-bottom: 1rem;
        margin-left: 1rem;
    }
    .add-pn-count-message > * {
        flex:1
    }
    .pn-save {
        width: 100%;
        border-radius: 25px;
        margin-top: 5px;
        background-color: #8BC4C1;
        height: 52px;
        width: 257px;
    }
    .pn-value {
        border-radius: 25px;
        white-space: nowrap;
    }
    .pn-count-info {
        display: flex;
        flex-wrap: nowrap;
        &.hazard {
            .score-hazard-icon {
                width: 20px;
                height: 20px;
                margin: 0 0.25rem;
            }
            .pn-value {
                color: $red;
            }
        }
        &:not(.hazard) {
            .score-hazard-icon {
                display: none;
            }
        }
    }

    .pn-count-info,
    .duc,
    .deg {
        margin-right: 1rem;
    }

    .duc,
    .deg {
        &.hazard {
            color: $red;
        }
    }

    .actions {
        display: flex;
        align-items: center;
        margin-left: auto;
        margin-right: 0.5rem;

        .changed-by-user {
            margin-right: 0.5rem;
        }
    }

    .pn-duc-deg-dialog {
        min-width: 100%;
        position: absolute;
        right: 0;
    }
    .pn-change-confirmation-dialog {
        width: 247px;
        height: 184px;
        border: 1px solid #FF5951;
        padding: 15px;
    }
    .pn-change-confirmation-dialog > .inner-text {
        width: 194px;
        height: 72px;
        color: #BCBCBC;
        letter-spacing: 0px;
        .warning-label {
            color: $red;
        }
    }
}
</style>
